import { AuthGuard, LoginGuard } from './services/authentication/auth.guard';
import { HomePageComponent } from './home-page/home-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { OfflinePageComponent } from './offline-page/offline-page.component';

const webOnlyRoutes: Routes = environment.environmentName === 'web' ? [
  {
    path: 'learning-toolkit',
    loadChildren: () =>
      import('./learning-toolkit/learning-toolkit.module').then(m => m.LearningToolkitModule),
    canActivate: [AuthGuard]
  }
] : [];

const routes: Routes = [
{ path: '', component: HomePageComponent, canActivate: [AuthGuard] },
{ path: 'offline', component: OfflinePageComponent },
{
  path: 'login',
  loadChildren: () =>
    import('./user/user.module').then(m => m.UserModule)
},
{
  path: 'notes',
  loadChildren: () =>
    import('./notes/notes.module').then(m => m.NotesModule),
  canActivate: [AuthGuard]
},
{
  path: 'export',
  loadChildren: () =>
    import('./export/export.module').then(m => m.ExportModule),
  canActivate: [AuthGuard]
},
{
  path: 'insertion-point',
  loadChildren: () =>
    import('./insertion-point/insertion-point.module').then(m => m.InsertionPointModule),
  canActivate: [AuthGuard]
},
{
  path: 'notebooks',
  loadChildren: () =>
    import('./notebooks/notebooks.module').then(m => m.NotebooksModule),
  canActivate: [AuthGuard]
},
{
  path: 'reviews',
  loadChildren: () =>
    import('./reviews/reviews.module').then(m => m.ReviewsModule),
  canActivate: [AuthGuard]
},
{
  path: 'settings',
  loadChildren: () =>
    import('./settings/settings.module').then(m => m.SettingsModule),
  canActivate: [AuthGuard]
},
{
  path: 'subscription',
  loadChildren: () =>
    import('./subscription/subscription.module').then(m => m.SubscriptionModule),
    canActivate: [LoginGuard]
},
{
  path: 'account',
  loadChildren: () =>
    import('./account/account.module').then(m => m.AccountModule),
    canActivate: [LoginGuard]
},
{
  path: 'integrations',
  loadChildren: () =>
    import('./integrations/integrations.module').then(m => m.IntegrationsModule),
    canActivate: [AuthGuard]
},
...webOnlyRoutes
];

@NgModule({
  imports: [RouterModule.forRoot(routes,  {
    /*anchorScrolling: 'enabled',
    relativeLinkResolution: 'corrected',
    initialNavigation: 'enabled',
    scrollPositionRestoration: 'top',*/
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
